<template>
  <div class="ele-body">
   <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
     <!-- 搜索表单 -->
     <el-form :model="table.where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="7" :sm="12">
            <el-form-item label="日期范围:">
             <el-date-picker v-model="daterange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" class="ele-fluid" @change="onDateRangeChoose" />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="学生姓名:">
              <el-input v-model.trim="table.where.studentName" placeholder="请输入学生姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="14" :sm="12">
            <div class="ele-form-actions">
             <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="
                (table.where = {
                  startTime: $util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
                  endTime: $util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
                  classId: classId,
                }) && $refs.table.reload()
  ">重置</el-button>
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" highlight-current-row height="calc(100vh - 200px)">
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip min-width="110" />
         <el-table-column prop="branchName" label="部系" show-overflow-tooltip min-width="110" />
          <el-table-column prop="gradeName" label="年级" show-overflow-tooltip min-width="110" />
          <el-table-column prop="className" label="班级" show-overflow-tooltip min-width="110" />
         <el-table-column prop="createTime" label="考勤时间" show-overflow-tooltip width="180" align="center" />
          <el-table-column prop="lateTime" label="迟到时间段" show-overflow-tooltip min-width="110" align="center" />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
import { studentLateRecordExport } from '@/config/api'; //修改角色权限

  export default {
    name: 'Index',
    data() {
      return {
        loading: false, // 加载状态
        table: {
          // 表格配置
          url: '/studentLate/studentLateRecordPage',
          where: {
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        classId: null,
        daterange: [this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'), this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59')],
      };
  },
  methods: {
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        studentLateRecordExport(this.table.where).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
